// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/ui/confirmPop.less
// module id = 1840
// module chunks = 148